// Score subscore breakdown — matches /docs/OpportunityScoring.md rubric.
// If an opportunity has explicit subscores in intelligenceMeta.subscores, use those;
// else derive plausible defaults from existing data so the UI can always render.

const SUBSCORE_DEFS = [
  { key: "signal",       label: "قوة الإشارة",       weight: 0.25 },
  { key: "actionability",label: "قابلية التنفيذ",    weight: 0.20 },
  { key: "timeliness",   label: "التوقيت",           weight: 0.15 },
  { key: "impact",       label: "الأثر السوقي",       weight: 0.15 },
  { key: "uniqueness",   label: "التميّز",            weight: 0.15 },
  { key: "fit",          label: "الملاءمة",           weight: 0.10 },
];

export const getSubscoreDefinitions = () => SUBSCORE_DEFS;

/** Derive per-subscore values (0-100) from opportunity + meta.
 *  Deterministic so the same opportunity always shows the same breakdown. */
export const deriveSubscores = (opportunity) => {
  const meta = opportunity.meta || {};
  const base = opportunity.score;
  const confidence = meta.confidence ?? base;
  const impact = { national: 90, regional: 80, local: 60 }[meta.marketImpact] ?? base;
  const timeliness =
    { urgent: 95, "30-days": 80, flexible: 60 }[meta.timeSensitivity] ?? base;
  const uniqueness =
    meta.status === "emerging" || meta.status === "high-potential" ? base + 5 : base;
  const actionability = meta.recommendedAction ? Math.max(base, 80) : base;

  const clamp = (n) => Math.min(100, Math.max(0, Math.round(n)));

  return [
    { ...SUBSCORE_DEFS[0], value: clamp(confidence) },
    { ...SUBSCORE_DEFS[1], value: clamp(actionability) },
    { ...SUBSCORE_DEFS[2], value: clamp(timeliness) },
    { ...SUBSCORE_DEFS[3], value: clamp(impact) },
    { ...SUBSCORE_DEFS[4], value: clamp(uniqueness) },
    { ...SUBSCORE_DEFS[5], value: clamp(base) },
  ];
};
